import { render, staticRenderFns } from "./main.vue?vue&type=template&id=ba6b644a"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba6b644a')) {
      api.createRecord('ba6b644a', component.options)
    } else {
      api.reload('ba6b644a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=ba6b644a", function () {
      api.rerender('ba6b644a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TablePagination/src/main.vue"
export default component.exports